// src/pages/help/TutorialRedirect.jsx
//
// Role-aware bridge between the React app and the standalone HTML
// walkthroughs in /public. Opens the right .html file in a new tab so
// the user keeps their place in the app, then sends them back to where
// they came from.
//
// Mapped roles (others fall back to "staff"):
//   staff       → tutorial-staff.html
//   manager     → tutorial-manager.html
//   admin       → tutorial-manager.html  (admins see the manager flow)
//   executive   → tutorial-executive.html
//   superadmin  → tutorial-executive.html

import React, { useEffect } from "react";

const TUTORIAL_MAP = {
  staff:      "/tutorial-staff.html",
  manager:    "/tutorial-manager.html",
  admin:      "/tutorial-manager.html",
  executive:  "/tutorial-executive.html",
  superadmin: "/tutorial-executive.html",
};

export default function TutorialRedirect() {
  useEffect(() => {
    let role = "staff";
    try {
      const u = JSON.parse(localStorage.getItem("user") || "null");
      if (u?.role) role = String(u.role).toLowerCase();
      // Honour secondary roles too — if any of the higher-role keys appear
      // in the CSV `roles` field, pick the most permissive of those present.
      const csv = (u?.roles || "").split(",").map((r) => r.trim().toLowerCase());
      if (csv.includes("superadmin") || csv.includes("executive")) role = "executive";
      else if (csv.includes("admin") || csv.includes("manager"))   role = "manager";
    } catch {}

    const url = TUTORIAL_MAP[role] || TUTORIAL_MAP.staff;
    // Open in a new tab; if blocked by popup-blocker, fall back to nav.
    const win = window.open(url, "_blank", "noopener,noreferrer");
    if (!win) {
      window.location.href = url;
      return;
    }
    // Send the user back where they came from. history.back() is the
    // friendliest option; fall back to the dashboard.
    setTimeout(() => {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = "/messenger/dashboard";
      }
    }, 50);
  }, []);

  return (
    <div style={{
      minHeight: "100vh",
      background: "#080808",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#555",
      fontSize: 14,
    }}>
      Opening your walkthrough…
    </div>
  );
}
